import type { Patient } from '@medplum/fhirtypes'

export function getPatientName(patient: Patient) {
  const name = patient.name?.[0]
  return {
    firstName: name?.given?.[0] || '',
    middleName: name?.given?.[1] || '',
    lastName: name?.family || '',
  }
}

export function formatFhirDob(birthDate?: string): string {
  if (!birthDate) return ''
  const [y, m, d] = birthDate.split('-')
  return `${m}/${d}/${y}`
}

export function getPatientAddress(patient: Patient) {
  const addr = patient.address?.find((a) => a.use !== 'old')
  return {
    line: addr?.line?.join(', ') || '',
    city: addr?.city || '',
    state: addr?.state || '',
    zip: addr?.postalCode || '',
    country: addr?.country || 'US',
    cityStateZip: [addr?.city, addr?.state, addr?.postalCode].filter(Boolean).join(', '),
  }
}

export function getPatientPhone(patient: Patient): string {
  return patient.telecom?.find((t) => t.system === 'phone')?.value || ''
}

export function getPatientEmail(patient: Patient): string {
  return patient.telecom?.find((t) => t.system === 'email')?.value || ''
}

export function getPatientSex(patient: Patient): string {
  const birthSexExt = patient.extension?.find(
    (ext) => ext.url === 'http://hl7.org/fhir/us/core/StructureDefinition/us-core-birthsex',
  )
  if (birthSexExt?.valueCode) return birthSexExt.valueCode.toUpperCase()

  // Fallback to Patient.gender when birthsex extension is absent (e.g. CCD imports)
  const gender = patient.gender?.toLowerCase()
  if (gender === 'male') return 'M'
  if (gender === 'female') return 'F'
  return ''
}

export function todayFormatted(): string {
  const now = new Date()
  const mm = String(now.getMonth() + 1).padStart(2, '0')
  const dd = String(now.getDate()).padStart(2, '0')
  const yyyy = now.getFullYear()
  return `${mm}/${dd}/${yyyy}`
}
